import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import 'rxjs';


@Injectable({
  providedIn: 'root',
})

export class RequestService {

  apiUrlPrefix = environment.backendUrl;

  constructor(private _http: HttpClient) { }


  post(url: string, body: any, headers?: HttpHeaders): Observable<any> {
    const fullUrl: string = this.apiUrlPrefix + url;
    const opts = headers ? { headers: headers } : {};
    console.log(headers);
    console.log(opts);
    return this._http.post(fullUrl, body, opts);
  }

  patch(url: string, body: any, headers?: HttpHeaders): Observable<any> {
    const fullUrl: string = this.apiUrlPrefix + url;
    const opts = headers ? { headers: headers } : {};
    return this._http.patch(fullUrl, body, opts);
  }

  get(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<any> {
    const fullUrl: string = this.apiUrlPrefix + url;
    const opts: any = params ? { params: params } : {};
    if (headers) opts['headers'] = headers;
    return this._http.get(fullUrl, opts);
  }

  put(url: string, body: any, headers?: HttpHeaders): Observable<any> {
    const fullUrl: string = this.apiUrlPrefix + url;
    const opts = headers ? { headers: headers } : {};
    return this._http.put(fullUrl, body, opts);
  }

  delete(url: string, headers?: HttpHeaders): Observable<any> {
    const fullUrl: string = this.apiUrlPrefix + url;
    const opts = headers ? { headers: headers } : {};
    return this._http.delete(fullUrl, opts);
  }

  postFileService(url: string, data: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': "" });
    return this._http.post(url, data, { headers: headers });
  }

}
